// service/dados-compartilhados.service.ts
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CompartilharDadosEntreComponentsService {
  private dadosDeContratoCompartilhadoSubject: BehaviorSubject<any> =
    new BehaviorSubject<any>(null);
  constructor() {}

  enviarDadosParaOutroComponent(dados: any): void {
    this.dadosDeContratoCompartilhadoSubject.next(dados);
  }

  obterDadosCompartilhados(): Observable<any> {
    return this.dadosDeContratoCompartilhadoSubject.asObservable();
  }
}
